(() => {
  // Select Forms - Cart page & Cart drawer
  const forms = Array.from(document.querySelectorAll("form#cart, form#CartDrawer-Form"));
  const details = Array.from(document.querySelectorAll(".cart__b2b-field details"));
  const endpoint = window.digismoothieB2bApp.appUrl; // Comes from theme settings
  let isFetching = false;
  let canSubmit = false;

  async function fetchB2bAppEndpoint(payload) {
    payload.myshopify_domain = window.Shopify.shop;
    const response = await fetch(window.digismoothieB2bApp.appUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": window.digismoothieB2bApp.lang
      },
      body: JSON.stringify(payload)
    });
    return await response.json();
  }

  const setIsFetching = (fetching) => {
    isFetching = fetching;
    document.body.classList.remove("b2b-vat-fetching");
    if (fetching) {
      document.body.classList.add("b2b-vat-fetching");
      return;
    }
  };

  const toggleInputError = ({ input, message = "" }) => {
    if (!input) return;
    const messageContainer = input.parentElement.querySelector(".cart__b2b-error");
    input.classList.remove("input--error");
    messageContainer.innerText = message;
    if (message.length > 0) input.classList.add("input--error");
  };

  const cloneInputsToForm = (form) => {
    if (!form) return;
    const inputs = document.querySelectorAll(".b2b-input");
    inputs.forEach((input) => {
      if (!input.value) return;
      const inputClone = input.cloneNode();
      inputClone.value = input.value;
      inputClone.type = "hidden";
      form.appendChild(inputClone);
    });
  };

  const handleFormSubmit = async (e) => {
    const form = e.target;
    if (!form) return;

    if (isFetching) {
      e.preventDefault();
      return;
    }

    // Select all inputs (cart and/or cart drawer)
    const companyNameInputs = document.querySelectorAll("#firma");
    const companyVatIdInputs = document.querySelectorAll("#dic");
    const companyIdInputs = document.querySelectorAll("#ico");
    const emailInputs = document.querySelectorAll("#email");
    const allInputs = document.querySelectorAll(".b2b-input");

    // Get values
    const company_name = Array.from(companyNameInputs).find((input) => input.value)?.value || "";
    const vat = Array.from(companyVatIdInputs).find((input) => input.value)?.value || "";
    const company_id = Array.from(companyIdInputs).find((input) => input.value)?.value || "";
    const email = Array.from(emailInputs).find((input) => input.value)?.value || "";

    // Clear erorrs - if any
    allInputs.forEach((input) => toggleInputError({ input }));

    // If can submit or no company information given - continue to checkout
    if (canSubmit || (!company_name && !vat && !company_id)) {
      return;
    }

    // Prevent submit to checkout
    e.preventDefault();

    try {
      // Set fetching state & send API request
      setIsFetching(true);
      const response = await fetchB2bAppEndpoint({ company_id, company_name, email, vat });

      // Handle error:
      if (response.errors && Object.keys(response.errors).length > 0) {
        // Open details so the user can see the error
        details.forEach((detail) => (detail.open = true));

        // Highlight inputs & display message
        for (const key in response.errors) {
          const inputError = response.errors[key];
          const message = typeof inputError === "string" ? inputError : inputError.join(" ");

          switch (key) {
            case "company_id":
              companyIdInputs.forEach((input) => toggleInputError({ input, message }));
              break;
            case "company_name":
              companyNameInputs.forEach((input) => toggleInputError({ input, message }));
              break;
            case "email":
              emailInputs.forEach((input) => toggleInputError({ input, message }));
              break;
            case "vat":
              companyVatIdInputs.forEach((input) => toggleInputError({ input, message }));
              break;
          }
        }
        setIsFetching(false);
        return;
      }

      // Handle success:
      canSubmit = true;
      const checkoutButton = document.querySelector(`button[type='submit'][form='${form.id}']`);
      if (checkoutButton) {
        cloneInputsToForm(form);
        checkoutButton.click();
      }
    } catch (error) {}

    setIsFetching(false);
  };

  const init = () => {
    if (!endpoint) {
      console.error("Missing: B2B endpoint");
      return;
    }

    forms.forEach((form) => {
      form.addEventListener("submit", handleFormSubmit);
    });
  };

  init();
})();
